export default __webpack_public_path__ + "static/media/cover (1).9df78c04.svg";